module.exports = __webpack_public_path__ + "static/media/YB5M07_4.6133dcfc.jpg";